/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { BooleanModelImpl } from "abreact/expression/ui/editor/impl/model/impl/BooleanModelImpl";
import { AbstractModelMediatorImpl } from "abreact/expression/ui/editor/impl/model/mediator/AbstractModelMediatorImpl";
export class BooleanModelMediatorImpl extends AbstractModelMediatorImpl {
  createDefault() {
    return new BooleanModelImpl({
      withSingleRow: true,
      expressionDomainModel: this.expressionDomainModel
    });
  }
  importInternal(expExpressionDefinition, generateId) {
    return new BooleanModelImpl({
      expExpressionDefinition: expExpressionDefinition,
      generateId: generateId,
      expressionDomainModel: this.expressionDomainModel,
      summaryGenerator: this.summaryGenerator
    });
  }
}
//# sourceMappingURL=BooleanModelMediatorImpl.js.map
